<template>
  <div class="container">
    <div class="row">
      <div class="col-md-16 col-md-offset-4">
        <form class="form-horizontal" @submit.prevent="submit" style="margin-top: 100px">
          <div class="text-center" style="margin-bottom: 20px">
            <img src="/img/logo.png">
          </div>

          <div class="panel panel-default panel-login">
            <div class="panel-body">
              <EmailFormGroup
                  v-model="data.email"
                  name="email"
                  label="Email"
                  :error="getError('email')"
              />

              <PasswordFormGroup
                  v-model="data.password"
                  name="password"
                  label="Password"
                  :error="getError('password')"
              />

              <PasswordFormGroup
                  v-model="data.password_confirmation"
                  name="password_confirmation"
                  label="Password Confirmation"
                  :error="getError('password_confirmation')"
              />

              <hr>

              <SubmitFormGroup button-class="btn-black"/>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import notify from '@/notify'
import EmailFormGroup from '@/vendor/forms/FormGroups/Horizontal/Email'
import Errors from '@/mixins/Errors'
import PasswordFormGroup from '@/vendor/forms/FormGroups/Horizontal/Password'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'

export default {
  components: {EmailFormGroup, PasswordFormGroup, SubmitFormGroup},

  props: ['token'],

  mixins: [Errors],

  data() {
    return {
      data: {}
    }
  },

  methods: {
    submit() {
      axios.post('/api/v2/password-resets', {...this.data, 'password_token': this.token})
          .then(response => {
            notify.success('The password was reset')

            this.$router.push('/login')
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
